import { Fragment, memo } from 'react'
import { HighlightedMatchSpan } from '../../common/HighlightedSearchSpan'
import { escapeRegExp, sortStringMatches } from './helpers'

interface HighlightedMatchProps {
    source: string
    searchString: string
    tabId?: string
}

const HighlightedMatch = memo(
    ({ source = '', searchString = '', tabId }: HighlightedMatchProps) => {
        const resolvedSource =
            tabId === 'tags' ? sortStringMatches(source, searchString) : source

        const re = new RegExp(`(${escapeRegExp(searchString)})`, 'gi')
        const splitted = resolvedSource.split(re)

        const pushed = splitted.map((slice, i) => {
            return i % 2 !== 0 ? (
                <Fragment key={i}>
                    <HighlightedMatchSpan data-testid="Fragment__HighlightedMatch">
                        {slice}
                    </HighlightedMatchSpan>
                </Fragment>
            ) : (
                <Fragment key={i}>{slice}</Fragment>
            )
        })

        return <>{pushed}</>
    },
)

export default HighlightedMatch
